'use client'
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography/Typography.js';

const SupportLinks = ({ supportEmail, supportUrls, }) => {
    const { t } = useTranslation();
    if (!supportEmail && !supportUrls) {
        return null;
    }
    return (jsxs(Fragment, { children: [supportEmail && (jsxs(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_need_help_section.contact_support', children: [t('dyn_need_help_section.contact_support'), ":", ' ', jsx(Typography, { variant: 'body_small', color: 'link', as: 'span', children: jsx("a", { href: `mailto:${supportEmail}`, children: supportEmail }) })] })), supportUrls &&
                Object.entries(supportUrls).map(([key, url]) => {
                    const platformName = key.charAt(0).toUpperCase() + key.slice(1);
                    return (jsxs(Typography, { variant: 'body_small', color: 'secondary', copykey: 'dyn_need_help_section.visit_platform', children: [t('dyn_need_help_section.visit_platform', {
                                platform: platformName,
                            }), ":", ' ', jsx(Typography, { variant: 'body_small', color: 'link', as: 'span', children: jsx("a", { href: url, rel: 'noreferrer', target: '_blank', children: url }) })] }, key));
                })] }));
};

export { SupportLinks };
